export default {"src":"/_next/static/media/b4.2ac9616b.svg","height":65,"width":159,"blurWidth":0,"blurHeight":0};